import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { authApi } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await authApi.get("/auth/me");
      setUser(data?.authenticated ? data : null);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Returning from the OAuth callback? Let AuthCallback exchange the
    // session_id first — skip the /me check to avoid a spurious 401.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try {
      await authApi.post("/auth/logout");
    } catch {
      /* best effort */
    }
    localStorage.removeItem("bk_auth_token");
    setUser(null);
  };

  const applySession = (data) => {
    if (data?.session_token) localStorage.setItem("bk_auth_token", data.session_token);
    setUser(data || null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth, applySession, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
